import { ConsumableOverviewThemeSizeConfig } from './types';

const medium: ConsumableOverviewThemeSizeConfig = {
  consumableOverview: {},
};

export default medium;
